import CloseIcon from './CloseIcon.jsx'
export default CloseIcon
